import { ButtonFilterOptions } from '@/components/custom';
import { getSelectOptions } from '@/functions';
import { useQueryParams } from '@/hooks';
import type { ISelectOption } from '@/interfaces';
import type { ITransactionFiltersProps } from '@/interfaces';

const VARIABLES = {
	keyNameType: 'type',
	keyNameCategory: 'category'
};

const TransactionFilters = ({ isLoading }: ITransactionFiltersProps) => {
	const { updateSearchParams, urlSearchParams } = useQueryParams([]);

	const filterOptions = {
		type: urlSearchParams.getAll(VARIABLES.keyNameType),
		category: urlSearchParams.getAll(VARIABLES.keyNameCategory)
	};

	const handleOnChangeFilter = (key: string, options: ISelectOption[]) =>
		updateSearchParams(prevUrlSearchParams => {
			const currentValues = prevUrlSearchParams.getAll(key);
			currentValues.forEach(option => {
				prevUrlSearchParams.delete(key, option);
			});
			options.forEach(option => {
				prevUrlSearchParams.append(key, option.value as string);
			});
			return prevUrlSearchParams;
		});

	return (
		<div className="flex flex-wrap gap-2">
			<ButtonFilterOptions
				disabled={isLoading}
				options={getSelectOptions('TransactionTypeEnum')}
				onChange={options => handleOnChangeFilter(VARIABLES.keyNameType, options)}
				value={filterOptions.type}
				text="Type"
			/>
			<ButtonFilterOptions
				disabled={isLoading}
				options={getSelectOptions('TransactionCategoryEnum')}
				onChange={options => handleOnChangeFilter(VARIABLES.keyNameCategory, options)}
				value={filterOptions.category}
				text="Catégorie"
			/>
		</div>
	);
};

export default TransactionFilters;
